import { useNavigate } from "react-router-dom";
import Btn from "../../components/btn/Btn";
import Landing from "../../components/landing/Landing";
import WebLayout from "../../components/WebLayout";

export const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <WebLayout>
      <Landing title="404" from="Error" page="Oops!" />
      <div className="error_sec p_t p_b">
        <h2>Page not found.</h2>
        <p>
          It looks like that page does not exist. Please check the URL and try
          again.
        </p>
        <Btn title="Back To Home" onClick={() => navigate("/")} />
      </div>
    </WebLayout>
  );
};
export default ErrorPage;
